import { useState } from 'react';
import { Autocomplete, SelectOption } from '@recargas-dominicanas/core/components';
import { type Field, useAsyncEffect } from '@recargas-dominicanas/core/utils';
import { type IBusiness } from '@recargas-dominicanas/core/types';
import { BusinessApi } from '@recargas-dominicanas/core/api';
import { style } from './business-select.module.css';

interface Props {
  className?: string;
  label?: string;
  icon: string;
  placeholder: string;
  field: Field<string>;
}

export function BusinessSelect(props: Props) {

  const {
    className,
    label,
    icon,
    placeholder, 
    field 
  } = props;

  const [businesses, setBusinesses] = useState<IBusiness[]>();

  useAsyncEffect(async () => {
    setBusinesses(await BusinessApi.search(''));
  });

  async function handleSearch(value?: string) {
    setBusinesses(await BusinessApi.search(value));
  }

  return (
    <Autocomplete
      style={{ 
        ...style.autocomplete, 
        container: `${style.autocomplete.container} ${className}` 
      }}
      label={label}
      icon={icon}
      placeholder={placeholder}
      formField={field}
      onSearch={handleSearch}>
      { 
        businesses?.map(business => (
          <SelectOption 
            key={business.id}
            value={business.id} 
            label={business.name}>
            <div className={style.item}>
              <span className={style.id}>{business.id.toString().padStart(2, '0')}</span>
              <span className={style.name}>{business.name}</span>
            </div>
          </SelectOption>
        ))
      }
    </Autocomplete>
  );
}
